// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"AddResidentBuilding--next-sr-only--1swAKJl","dialog":"AddResidentBuilding--dialog--3FlVeNV"};